function change_card_colors(input, event) {
  event.preventDefault();    
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var selectedVariantId = input.getAttribute('data-variant-id');
  var newProductId = input.getAttribute('data-product-id');
  var newPrice = input.getAttribute('data-price');

  if (!newImageUrl) return;
  
  var productCard = input.closest('.product-card');
  if (!productCard) return;
  
  var primaryImage = productCard.querySelector('.product-card__image--primary');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    primaryImage.setAttribute('src', newImageUrl);
    if(primaryImage.hasAttribute('data-src')) {
      primaryImage.setAttribute('data-src', newImageUrl);
    }
    if(primaryImage.hasAttribute('srcset')) {
      primaryImage.setAttribute('srcset', newImageUrl);
    }
  }
  
  var secondaryImage = productCard.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    secondaryImage.setAttribute('src', newSecondaryImageUrl);
    if(secondaryImage.hasAttribute('data-src')) {
      secondaryImage.setAttribute('data-src', newSecondaryImageUrl);
    }
    if(secondaryImage.hasAttribute('srcset')) {
      secondaryImage.setAttribute('srcset', newSecondaryImageUrl);
    }
  }
  
  var productTitle = productCard.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    if(newLink) {
      productTitle.href = newLink;
    }
  }
  
  var productPrice = productCard.querySelector('.product-price');
  if (productPrice && newPrice) {
    productPrice.textContent = newPrice;
  }
  
  if(newLink) {
    var mediaLink = productCard.querySelector('.product-card__media');
    if(mediaLink) {
      mediaLink.href = newLink;
    }
  }
  
  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    var allSwatches = swatchWrapper.querySelectorAll('.custom-swatch');
    allSwatches.forEach(function(item) {
      item.classList.remove('checked');
    });
  }
  input.classList.add('checked');

  var variantData = input.getAttribute('data-variants');
  if (variantData) {
    try {
      var variants = JSON.parse(variantData);
      var variantContainer = productCard.querySelector('.product-card__variant-container');
      if (variantContainer) {
        var html = '<div class="variant-box"><ul class="variant-list">';
        variants.forEach(function(variant) {
          html += '<li data-color="' + (variant.option1 ? variant.option1.toLowerCase() : '') + '">';
          html += '<product-form>';
          html += '<form method="post" action="/cart/add" id="product-form-main-' + newProductId + '-' + variant.id + '" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">';
          html += '<input type="hidden" name="form_type" value="product">';
          html += '<input type="hidden" name="utf8" value="✓">';
          html += '<input type="hidden" name="id" value="' + variant.id + '">';
          html += '<button type="submit" class="variant-item ' + (variant.available ? 'available' : 'unavailable') + '" ' + (variant.available ? '' : 'disabled') + '>';
          html += variant.title;
          html += '</button>';
          html += '</form>';
          html += '</product-form>';
          html += '</li>';
        });
        html += '</ul></div>';
        variantContainer.innerHTML = html;
      }
    } catch (e) {
      console.error('Error al parsear las variantes:', e);
    }
  }
}

function change_shop_the_look_colors(input, event) {
  event.preventDefault();
  var newImageUrl = input.getAttribute('data-image');
  var newSecondaryImageUrl = input.getAttribute('data-secondary');
  var newTitle = input.getAttribute('data-title');
  var newLink = input.getAttribute('data-link');
  var selectedVariantId = input.getAttribute('data-variant-id');
  var newPrice = input.getAttribute('data-price');
  var variantData = input.getAttribute('data-variants');
  if (!newImageUrl) return;
  var productRow = input.closest('.quick-buy-product-row');
  if (!productRow) return;
  var primaryImage = productRow.querySelector('.quick-buy-product__image img');
  if (primaryImage) {
    primaryImage.src = newImageUrl;
    if (primaryImage.hasAttribute('srcset')) primaryImage.srcset = newImageUrl;
  }
  var secondaryImage = productRow.querySelector('.product-card__image--secondary');
  if (secondaryImage && newSecondaryImageUrl) {
    secondaryImage.src = newSecondaryImageUrl;
    if (secondaryImage.hasAttribute('srcset')) secondaryImage.srcset = newSecondaryImageUrl;
  }
  var productTitle = productRow.querySelector('.product-title');
  if (productTitle && newTitle) {
    productTitle.textContent = newTitle;
    if (newLink) productTitle.href = newLink;
  }
  var productPrice = productRow.querySelector('.product-price');
  if (productPrice && newPrice) productPrice.textContent = newPrice;
  var swatchWrapper = input.closest('.color_swatches--wrapper');
  if (swatchWrapper) {
    swatchWrapper.querySelectorAll('.custom-swatch').forEach(function(s) {
      s.classList.remove('checked');
    });
  }
  input.classList.add('checked');
  var hiddenInput = productRow.querySelector('input[type="hidden"][name$="[id]"]');
  if (hiddenInput && selectedVariantId) hiddenInput.value = selectedVariantId;
  var optsContainer = productRow.querySelector('.modal-product--variant-options');
  if (optsContainer) optsContainer.innerHTML = '';
  var oldOnlyBtn = productRow.querySelector('.modal-product--variant-only-option');
  if (oldOnlyBtn) oldOnlyBtn.remove();
  if (!variantData) return;
  var variants;
  try {
    variants = JSON.parse(variantData);
  } catch (err) {
    console.error(err);
    return;
  }
  var firstAvailable = variants.findIndex(function(v) { return v.available; });
  if (variants.length > 1 && optsContainer) {
    variants.forEach(function(variant, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'modal-product--variant-option-button';
      btn.textContent = variant.title;
      btn.dataset.variantId = variant.id;
      if (!variant.available) {
        btn.disabled = true;
        btn.style.color = 'rgba(28, 27, 27, 0.35)';
      }
      if (idx === firstAvailable && variant.available) {
        btn.classList.add('active');
        hiddenInput.value = variant.id;
      }
      btn.addEventListener('click', function() {
        optsContainer.querySelectorAll('.modal-product--variant-option-button').forEach(function(b) {
          b.classList.remove('active');
        });
        if (variant.available) {
          btn.classList.add('active');
          hiddenInput.value = variant.id;
        }
        updateShopAllButtonState();
      });
      optsContainer.appendChild(btn);
    });
  } else if (variants.length === 1) {
    var single = variants[0];
    hiddenInput.value = single.id;
    var onlyBtn = document.createElement('button');
    onlyBtn.type = 'button';
    onlyBtn.className = 'modal-product--variant-only-option';
    onlyBtn.textContent = single.title;
    onlyBtn.dataset.variantId = single.id;
    if (!single.available) {
      onlyBtn.disabled = true;
      onlyBtn.style.color = 'rgba(28, 27, 27, 0.35)';
      onlyBtn.style.borderBottom = 'none';
    } else {
      onlyBtn.classList.add('active');
    }
    onlyBtn.addEventListener('click', function() {
      if (single.available) {
        hiddenInput.value = single.id;
      }
      updateShopAllButtonState();
    });
    hiddenInput.insertAdjacentElement('afterend', onlyBtn);
  }
  updateShopAllButtonState();
}

function updateShopAllButtonState() {
  var disable = false;
  document.querySelectorAll('.quick-buy-product-row').forEach(function(row) {
    var hid = row.querySelector('input[type="hidden"][name$="[id]"]');
    if (hid) {
      var id = hid.value;
      var btn = row.querySelector('.modal-product--variant-option-button[data-variant-id="' + id + '"]') ||
                row.querySelector('.modal-product--variant-only-option[data-variant-id="' + id + '"]');
      if (btn && btn.disabled) disable = true;
    }
  });
  var shopAll = document.querySelector('.shop-all-modal-button');
  if (shopAll) shopAll.disabled = disable;
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.custom-swatch').forEach(function(swatch) {
    swatch.addEventListener('click', function(e) {
      change_shop_the_look_colors(swatch, e);
    });
  });
  var form = document.getElementById('add-all-form');
  if (!form) return;
  updateShopAllButtonState();
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var formData = new FormData(form);
    var itemCount = parseInt(form.getAttribute('data-item-count'), 10);
    var items = [];
    for (var i = 0; i < itemCount; i++) {
      var id = formData.get('items[' + i + '][id]');
      var quantity = formData.get('items[' + i + '][quantity]');
      if (id) {
        items.push({
          id: parseInt(id, 10),
          quantity: quantity ? parseInt(quantity, 10) : 1
        });
      }
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    }).then(function(response) {
      if (!response.ok) throw new Error('Error al añadir productos al carrito');
      return response.json();
    }).then(function(data) {
      var modal = document.getElementById('shop-the-look-quick-buy-modal');
      if (modal) {
        modal.close();
        document.body.style.overflow = '';
      }
    }).catch(function(error) {
      console.error(error);
    });
  });
});